import { useTranslation } from 'react-i18next';

export const useTermsAndConditionsLabel = (): { hasOverride: boolean; termsLabel: string } => {
  const { t, i18n } = useTranslation(['common', 'terms']);
  const hasOverride = i18n.exists('terms:terms-and-conditions');
  const termsLabel = hasOverride
    ? t('terms:terms-and-conditions')
    : t('common:page.profile.terms-and-conditions.labels');

  return { hasOverride, termsLabel };
};
